import * as React from "react";
import { forwardRef } from "react";
const SvgIcClose = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "100%", height: "100%", viewBox: "0 0 24 24", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h24v24H0z", fill: "none" }));
const ForwardRef = forwardRef(SvgIcClose);
export { ForwardRef as ReactComponent };
